import React, { FC } from 'react';
import { TTrial } from '@pages/Trials/components/TrialsTable/types';

export const physiciansFormatter: FC<TTrial> = (trial) => {
  const physicianName = trial.physicians.name;

  return <ul>{physicianName}</ul>;
};
